import Login from '../pages/login/login';
import ForgotPassword from '../pages/forgotPassword/forgotPassword';
import ResetPassword from '../pages/resetPassword/resetPassword';
import { RouteProps } from './route';
import UserRegister from '../pages/userRegister/userRegister';

export const routes: Array<RouteProps> = [
  {
    exact: true,
    path: '/register',
    onlyPublic: true,
    Component: UserRegister,
  },
  {
    exact: true,
    path: '/login',
    onlyPublic: true,
    Component: Login,
  },
  {
    exact: true,
    path: '/forgot-password',
    onlyPublic: true,
    Component: ForgotPassword,
  },
  {
    exact: true,
    path: '/reset-password/:email',
    onlyPublic: true,
    Component: ResetPassword,
  },
];
